import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { Operation } from "src/app/shared/types/entity.type";
import { AuthenticationService } from "../../../../core/authentication/authentication.service";
import { DynamicFormComponent } from "../../../../shared/components/dynamic-form/dynamic-form.component";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { UserInfo } from "../../../../shared/types/user-info";
import { CompanyService } from "../company.service";
import { Company } from "../company.type";
import { CreateCompanyService } from "./create-company.service";

@Component({
  selector: "app-create-company",
  templateUrl: "./create-company.component.html",
  styleUrls: ["./create-company.component.css"],
  providers: [CreateCompanyService],
})
export class CreateCompanyComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  currentUser: UserInfo;
  questions: any;
  operation: Operation;
  constructor(
    public location: Location,
    private router: Router,
    private notificationService: NotificationService,
    private companyService: CompanyService,
    private questionsService: CreateCompanyService,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
    this.operation = Operation.create;
  }

  ngOnInit(): void {
    const options = {
      ...(this.currentUser.isGlobalAdmin() && {
        showFairMarketValueAndBookValue: true,
      }),
      ...(this.currentUser.isGlobal() && {
        partnerSkip: false,
        partnerEdit: true,
        canManageClientPriceEdit: true,
        skipManageClientPrice: false,
      }),
      ...(this.currentUser.isPartner() && {
        partnerValue: this.currentUser.partnerId,
        partnerSkip: true,
        partnerEdit: false,
        canManageClientPriceEdit: false,
        skipManageClientPrice: true,
      }),
      operation: this.operation,
    };

    this.questionsService.generateQuestions(options).subscribe((qs) => {
      this.questions = this.currentUser.isPartner() ? qs.filter((q) => q.key !== "partnerId") : qs;
    });
  }

  goBack(): void {
    this.location.back();
  }

  navigateToBulkMode(): void {
    this.router.navigate(["/companies/bulk-upload"]);
  }

  onSubmit(company: Company): void {
    if (company.logo) {
      company.logo = company.logo.split(",")[1];
    } else {
      delete company.logo;
    }

    this.companyService
      .createCompany(company)
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        (value: Company) => {
          this.notificationService.success("Company successfully created");
          this.router.navigate([`/companies/${value.id}`]);
        },
        (error) => {
          if (error.errors) {
            this.notificationService.error(error.errors[0].message);
          } else {
            this.notificationService.error(error);
          }
        },
      );
  }
}
